import SectionContainer from "../../ui/SectionContainer";
import HighlightBand from "../../ui/HighlightBand";

import { Description } from "./styles";

import Illustration from "../../../assets/images/sections/esp-evolution/illustration.png";
import BackgroundImage from "../../../assets/images/sections/esp-evolution/background.jpg";

const EspEvolution = () => {
  return (
    <SectionContainer backgroundImage={BackgroundImage} id="aboutUs">
      <Description>
        <h1>
          A ESP - EVOLUTION SOCCER PROGRAM - É MUITO MAIS DO QUE UMA ESCOLA DE
          FUTEBOL:
        </h1>

        <HighlightBand>
          <span>é um programa completo de formação humana e esportiva.</span>
        </HighlightBand>

        <p>
          Nossa missão é desenvolver crianças e adolescentes por meio do
          futebol, promovendo valores como trabalho em equipe, respeito,
          comprometimento, jogo limpo e perseverança.
        </p>

        <p>
          Com localização própria e atuante em mais de 20 unidades entre
          escolas, condomínios e clubes, possui uma abordagem pedagógica
          moderna, treinamentos planejados por faixas etárias e uma equipe de
          professores capacitados, em um ambiente seguro, acolhedor e desafiador
          para que cada aluno evolua dentro e fora do campo.
        </p>

        <p>
          Baseada na metodologia de craques como Caio Ribeiro e Denilson Show, a
          ESP une paixão pelo jogo com excelência na formação, preparando jovens
          atletas para os desafios do esporte e da vida.
        </p>
      </Description>
      <img src={Illustration} alt="imagem" />
    </SectionContainer>
  );
};

export default EspEvolution;
